export class ImageLoadWatcher {
    public static async waitForAllImagesToBeLoaded(imageElements: NodeListOf<HTMLImageElement>) {
        const imageLoadedPromises = Array.from(imageElements).map((imageElement) => {
            return new Promise<void>((resolve) => {
                if (imageElement.complete) {
                    resolve();
                } else {
                    imageElement.addEventListener('load', () => resolve());
                }
            });
        });
        await Promise.all(imageLoadedPromises);
        return;
    }
}
